import { generateErrors } from 'utilities/util'
import { ThunkDispatch } from 'redux-thunk'
import { Action } from 'redux'
import { TYPES } from 'action-types/exportJob'
import { TYPES as FILTER_TYPES } from 'action-types/filters';
import { callApiV3Get } from 'utilities/apiCaller'
import API from 'constants/api'
import { IStore } from 'reducers/index'
import { toCapital } from '../utilities/util'
import { TransportMode } from 'constants/modes';


const initialState = {
  totalCount: 0,
  page: 1,
  pageSize: 10,
  data: []
}
export const fetchSalesOrderData = (id: number, page?: number, pageSize?: number) => {
  return async (dispatch: ThunkDispatch<any, any, Action>, getState: () => IStore) => {
    dispatch({ type: TYPES.FETCH_EXPORT_JOB_SALES_ORDERS.PENDING })
    try {
      const sorting = getState().filters.column ? {
        order: getState().filters.order,
        column: getState().filters.column,
        } : {
          order: 0,
          column: 'id',
      } 
      const pageNo = getState().filters.page;
      const res = await callApiV3Get(`${API.CostRevenueNew.getSalesOrders}/${id}/sales-orders?page=${pageNo}&pageSize=${pageSize}&column=${toCapital(sorting.column)}&order=${sorting.order}`, {}, { headers: { TransportMode: TransportMode.Ocean } })
      dispatch({ type: FILTER_TYPES.SET_TOTAL_COUNT, totalCount: res.data.totalCount });
      dispatch({ type: TYPES.FETCH_EXPORT_JOB_SALES_ORDERS.FULFILLED, salesOrderResponse: (res.status !== 200 ? initialState : res.data) })
    } catch (e) {
      const errors = generateErrors(e)
      dispatch({ type: TYPES.FETCH_EXPORT_JOB_SALES_ORDERS.REJECTED, errors })
    }
  }
}

export const setExportJobSalesOrderId = (salesOrderId: number) => ({
  type: TYPES.SET_EXPORT_JOB_SALES_ORDER_ID,
  salesOrderId
});

